/* s66-wire.js — buy box del clon 66 Roots: tramos por CANTIDAD (misma variante) -> add.js -> drawer.
   Patron probado (bw-wire): capturamos el submit UNA sola vez (sin doble-add) y repintamos el drawer. */
(function () {
  var QMAP = { t1: 1, t2: 3, t3: 5 };
  var current = "t1";

  function select(val) {
    if (!QMAP[val]) return;
    current = val;
    document.querySelectorAll(".s66-tier").forEach(function (t) {
      var on = t.getAttribute("data-tier") === val;
      t.classList.toggle("is-sel", on);
      var r = t.querySelector('input[type="radio"]'); if (r) r.checked = on;
    });
    document.querySelectorAll('form.s66-buyform [name="quantity"]').forEach(function (q) { q.value = QMAP[val]; });
  }

  function selectedQty(form) {
    var checked = (form && form.querySelector('.s66-tier input:checked')) || document.querySelector('.s66-tier input:checked');
    if (checked && QMAP[checked.value]) return QMAP[checked.value];
    return QMAP[current] || 1;
  }
  function variantId(form) {
    var i = form && form.querySelector('[name="id"]');
    return i ? i.value : null;
  }

  function init() {
    // tier selection (capture-phase: gana al JS del tema)
    document.addEventListener("click", function (e) {
      var tier = e.target.closest(".s66-tier"); if (!tier) return;
      var val = tier.getAttribute("data-tier"); if (!QMAP[val]) return;
      select(val);
    }, true);
    document.addEventListener("change", function (e) {
      var r = e.target; if (!r || !r.matches || !r.matches('.s66-tier input[type="radio"]')) return;
      e.stopPropagation();
      if (QMAP[r.value]) select(r.value);
    }, true);

    // ATC: UN solo listener en captura -> add.js -> renderContents del drawer (sin doble-add)
    document.addEventListener("submit", function (e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches("form.s66-buyform")) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var vid = variantId(form); var qty = selectedQty(form);
      if (!vid) { return; }
      var dr = document.querySelector("cart-drawer");
      var sections = (dr && typeof dr.getSectionsToRender === "function")
        ? dr.getSectionsToRender().map(function (s) { return s.id || s.section; })
        : ["cart-drawer", "cart-icon-bubble"];
      var btn = form.querySelector(".s66-atc"); var orig = btn && btn.textContent;
      if (btn) { btn.textContent = "ADDING…"; btn.disabled = true; }
      fetch("/cart/add.js", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: vid, quantity: qty }], sections: sections, sections_url: window.location.pathname })
      }).then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (res) {
        if (btn) { btn.textContent = orig; btn.disabled = false; }
        if (dr) {
          if (dr.classList) dr.classList.remove("is-empty");
          if (typeof dr.renderContents === "function") { try { dr.renderContents(res); return; } catch (x) {} }
          if (typeof dr.open === "function") { try { dr.open(); return; } catch (x) {} }
        }
        window.location.href = "/cart";
      }).catch(function () { if (btn) { btn.textContent = orig; btn.disabled = false; } window.location.href = "/cart"; });
    }, true);

    select("t1");
  }

  // evergreen countdown (resets a las 24h desde medianoche local) — solo visual, como la fuente
  function tick() {
    var els = document.querySelectorAll(".s66-cd");
    if (!els.length) return;
    var now = new Date();
    var end = new Date(now); end.setHours(23, 59, 59, 999);
    var d = Math.max(0, end - now);
    var h = Math.floor(d / 3.6e6), m = Math.floor(d % 3.6e6 / 6e4), s = Math.floor(d % 6e4 / 1e3);
    var p = function (n) { return (n < 10 ? "0" : "") + n; };
    els.forEach(function (el) { el.textContent = p(h) + ":" + p(m) + ":" + p(s); });
  }

  function boot() { init(); tick(); setInterval(tick, 1000); }
  if (document.readyState !== "loading") boot();
  else document.addEventListener("DOMContentLoaded", boot);
})();
